import { Action } from '@ngrx/store';
import { ColumnSortModel } from '../../grid/types/sorting.types';
import { CalendarGridColumnName } from '../../grid/types/column.types';

export enum CalendarSortingActionTypes {
  SetModel = '[Calendar Sorting] SetModel'
}

export class CalendarSortingSetModel implements Action {
  public readonly type = CalendarSortingActionTypes.SetModel;
  constructor(public payload: ColumnSortModel<CalendarGridColumnName>[]) {}
}

export type CalendarSortingActionUnion = CalendarSortingSetModel;
